import { useState as u, useEffect as h } from "react";
import { safeGetPos as i } from "../../utils/safe-get-pos.mjs";
const R = ({
  editor: r,
  getPos: c,
  nodeName: t
}) => {
  var p;
  const [e, f] = u(0);
  return h(() => {
    const a = (() => {
      const l = i(c);
      if (l === void 0) return 0;
      let o = 0;
      const n = r.state.doc.resolve(l);
      for (let s = n.depth; s >= 0; s--)
        t ? n.node(s).type.name === t && o++ : o++;
      return o;
    })();
    e !== a && f(a);
  }, [(p = r.state) == null ? void 0 : p.doc, c, t, e]), { realDepth: e };
};
export {
  R as useGetParentCount
};
